

































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import ChangePassword from '@/components/shared/ChangePassword.vue'
import {ruleMailValid} from '@/utils/validationRules'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import { AloNewsletter, getDefaultAloNewsletter } from './models/alo/AloNewsletter'
import { AloError } from './models/alo/AloError'
import { TemplateMail } from './enum/TemplateMail'
import { ApiUserRole } from './enum/ApiUserRole'

@Component({
  name: 'App',
  components:{ChangePassword}
})
export default class App extends Vue {  
  private showDrawerIcon = true
  private fixed = false
  private title = 'Aquadomic'
  private showSnack = false
  private openUserMenu = false
  private mailNews = ''
  private savingNewsletter = false
    
  //private showCovid = false

  private mainMenuItems = [
    { id:1, icon:'mdi-home', text: 'Accueil',            to: {name:'Home'}},
    //{ text: 'Réserver en ligne',  to: {name:'Reserver'}},
    { id:2, text: 'Activités enfants',          to: {name:'Enfants'}},
    { id:3, text: 'Activités adultes',          to: {name:'Adultes'}},
    { id:4, text: 'Piscines et réservations',       to: {name:'Piscines'}},
    { id:5, text: 'Domicile',       to: '/piscines/cours-a-domicile'},    
    { id:6, icon:'mdi-account', text: 'Mon compte',                  to: {name:'ProfilAccount'}}/*,    
    { text: 'Blog',               to: {name:'Blog'}}*/
  ]

  private footerItems = [
    {
      text: 'Nos conditions', links: [
        { to: {name:'MentionsLegales'},           text: 'Mentions légales'},
        { to: {name:'ConditionsGeneralesVente'} , text: 'Conditions générales de vente'},
        { to: {name:'Contact'},                   text: 'Nous contacter'},
        { to: {name:'ProfilAccount'},                     text: 'Mon compte'}
      ]
    }
  ]

  private sociauxItems = [    
    { to: 'https://www.facebook.com/aquadomic/', icon: 'mdi-facebook' },
    { to: 'https://twitter.com/aquadomic/', icon: 'mdi-twitter' },
    { to: 'https://www.instagram.com/aquadomic/', icon: 'mdi-instagram' },
    { to: 'https://www.linkedin.com/company/aquadomic/', icon: 'mdi-linkedin' }
  ]

  get panier(){
    return this.$store.myGetters.panier
  }

  
  get drawerOpen() {
    return this.$store.myGetters.drawerOpen
  }
  set drawerOpen(newValue){
    this.$store.myActions.UI_SET_DRAWER_OPEN(newValue)
  }
  get rightDrawerOpen() {
    return this.$store.myGetters.rightDrawerOpen
  }
  set rightDrawerOpen(newValue) {
    this.$store.myActions.UI_SET_RIGHT_DRAWER_OPEN(newValue)
  }

  get rightDrawerEnable() {
    return this.$store.myGetters.rightDrawerEnable
  }  

  set rightDrawerEnable(newValue:boolean) {
    this.$store.myActions.UI_SET_RIGHT_DRAWER_ENABLE(newValue)
  }
   
  get isAuthenticated(){
    return this.$store.myGetters.isAuthenticated
  }
    
  get showSnacks() {
     return this.$store.myGetters.snackMessages.length > 0
  }

  set showSnacks(newValue) {
    this.$store.myActions.UI_CLOSE_SNACKBAR()
  }
    
  get snackMessages(){
    return this.$store.myGetters.snackMessages
  }   

  get userName(){
    return this.isAuthenticated ?this.$store.myGetters.user.libelle:"Visiteur"
  }          
 
  get routemeta(): any {
    return this.$route.matched.reduce((a,item) => { return {...a,...item.meta}},{})
  }

  get drawerIcon(){
    return this.routemeta.drawerIcon || 'mdi-menu'
  }
    
  get rightDrawerIcon() {
    return this.routemeta.rightDrawerIcon || 'mdi-filter-variant'
  }
  
  get drawerRightWidth() {
    return 350
  }
      
  created() {            
    this.updateDrawer()   
    const urlParams = new URLSearchParams(window.location.search);
    const newsletter = urlParams.get("newsletter"); 
    if((newsletter?.length ?? 0) > 0) {      
      console.log("validNewsLetter")
      this.$store.myActions.ADM_NEWSLETTER_VALID_REQUEST(newsletter!).then((news:AloNewsletter)=>{
        this.$confirm(`La validation de l'adresse ${news.libelle} est maintenant terminé`,{title: "Validation inscription réussie",buttonTrueText:"Ok",buttonFalseText:""} as VuetifyConfirmObject)
      })
      .finally(()=> {
        urlParams.delete("urlParams")    
        window.history.replaceState({}, '', `${location.pathname}`); 
      })
    }
  }

  mounted(){
    this.onResize()
  }

  onResize(){
    //@ts-ignore
    this.$store.myActions.UI_SET_CONTENT_HEIGHT(window.innerHeight - this.$refs.appBar.$el.clientHeight - 20)            
  }

  @Watch('$route')
  onRouteChanged(to: string, from: string) {
    this.rightDrawerEnable = false
    this.updateDrawer()
    this.onResize()
  }  
  
  updateDrawer() {    
    //masque l'icon du drawer
    this.showDrawerIcon = this.showDrawerCmp  && !this.routemeta.hideDrawerIcon
    if(this.showDrawerIcon && !this.$vuetify.breakpoint.mobile) this.drawerOpen = true    
  }

  get showDrawerCmp(){
    return !!this.routemeta.drawerCmp && (this.routemeta?.drawerCmp != 'menu-administration' || this.$store.myGetters.canAccess([ApiUserRole.AdminPlateforme]))
  }

  

  toggleDrawer(){
    if(this.$vuetify.breakpoint.xsOnly) this.rightDrawerOpen = false
    this.drawerOpen = !this.drawerOpen 
  }

  toggleRightDrawer() {
    if(this.$vuetify.breakpoint.xsOnly) this.drawerOpen = false
    this.rightDrawerOpen = !this.rightDrawerOpen
  }

  logout() {       
    this.$store.myActions.AUTH_LOGOUT_REQUEST()  
  }

  changePassword() { (this.$refs.changePassword as ChangePassword).edit() }

  

  inscriptionNew(){
    if(ruleMailValid(this.mailNews) !== true){
      this.$confirm("Merci d'entrer un email valide afin de pouvoir vous inscrire à la newsletter",{title: "Attention",buttonTrueText:"Ok",buttonFalseText:""} as VuetifyConfirmObject)
    }    
    else{
      this.savingNewsletter = true
      const aloNews = getDefaultAloNewsletter(this.mailNews)
      aloNews.mtpId = TemplateMail.InscriptionNewsletter
      this.$store.myActions.ADM_NEWSLETTER_SAVE_REQUEST(aloNews).then(()=>{
        this.mailNews = '';
        this.$confirm("Nous avons bien pris en compte votgre demande d'inscription<br/>Pour valider celle ci merci de cliquer sur le lien que nous vous avons envoyé par mail",{title: "Inscription réussie",buttonTrueText:"Ok",buttonFalseText:""} as VuetifyConfirmObject)        
      }).catch((errorMessage:string)=>{        
        this.$confirm(errorMessage,{title: "Attention",buttonTrueText:"Ok",buttonFalseText:""} as VuetifyConfirmObject)        
      })
      .finally(()=>{
        this.savingNewsletter = false
      })
    }
  }

  get cssProps () {
    return {
        '--secondary-color': '#ec7404',
        '--primary-color': '#273f6b'
    }
  }
}

  
